// extracted by mini-css-extract-plugin
module.exports = {"label":"Login_label__1AuDG","input":"Login_input__3Fcny","button":"Login_button__1k1hd"};